(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["karghaa-product-help"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('karghaa-product-help')) {
  customElements.define('karghaa-product-help', class extends HTMLElement {
    connectedCallback() {
      this.abortController?.abort();
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      const updateLink = () => {
        const link = this.querySelector('a');
        const form = document.getElementById(this.dataset.formId);
        const variantId = form?.querySelector('[name="id"]')?.value;
        const ids = JSON.parse(this.dataset.variantIds);
        const titles = JSON.parse(this.dataset.variantTitles);
        const variantIndex = ids.findIndex(id => String(id) === variantId);
        const hasVariant = this.dataset.defaultVariant === 'false' && variantIndex !== -1;
        const url = new URL(this.dataset.productUrl);
        if (hasVariant) url.searchParams.set('variant', variantId);
        const variantLine = hasVariant ? `\n${this.dataset.variantLabel}: ${titles[variantIndex]}` : '';
        const message = `${this.dataset.opening}\n\n${this.dataset.productLabel}: ${url.href}${variantLine}\n\n${this.dataset.question}`;
        link.href = `https://wa.me/919599760069?text=${encodeURIComponent(message)}`;
      };
      this.addEventListener('click', updateLink, options);
      this.addEventListener('contextmenu', updateLink, options);
      document.addEventListener('variant:change', updateLink, options);
      updateLink();
    }
    disconnectedCallback() {
      this.abortController?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
